import React from "react"
import { H4 } from "../ui/typography"
import { Input } from "../ui/input"
import { Map, Marker } from "@vis.gl/react-google-maps"
import { Button } from "../ui/button"
import { MapPin } from "lucide-react"
import {
	GoogleAddressAutocomplete,
	AddressAutocompleteContainer,
	AddressAutocomplete,
} from "../primitives/AddressAutocomplete"
import { useAddressAutocomplete } from "../../hooks/useAddressAutocomplete"
import { getLatLng } from "use-places-autocomplete"
import { AddressType } from "@/state/draft/hqAddress"
import { useOSM } from "@/features/map/useOSM"
import { fromLatLon } from "@/features/map/fromLatLon"
import { OSMapComponent } from "@/features/map/OSMapComponent"

type AddAddressProps = {
	onAddressChange: (address: AddressType) => void
	value?: AddressType
	onSaveAddress: (address: AddressType) => void
}

const defaultAddress: AddressType = { address: "", latlon: [0, 0] }
export const AddAddress: React.FC<AddAddressProps> = (props) => {
	const [address, setAddress] = React.useState<AddressType>(
		props.value || defaultAddress
	)

	const hqAddr = useOSM({
		initialView: {
			center: fromLatLon([
				address.latlon[0] || 36.7783,
				address.latlon[1] || -119.4179,
			]),
			zoom: 15,
		},
		onMarkerDragEnd: (e) => {},
		defaultAddress: props.value?.address,
		onSelectedPlaceChange: (place) => {
			const addr: AddressType = {
				address: place.displayName,
				latlon: [place.lat, place.lon],
			}
			props.onAddressChange(addr)
			setAddress(addr)
		},
	})

	return (
		<div className="flex flex-col gap-8">
			<H4>Add Address</H4>
			<div>
				<AddressAutocomplete
					suggestions={hqAddr.autocomplete.suggestions}
					onSuggestionSelect={hqAddr.selectPlace}
					ref={hqAddr.autocomplete.сontainerRef}
				>
					<Input
						autoComplete="off"
						value={hqAddr.autocomplete.input.value}
						placeholder="Enter address"
						startIcon={<MapPin className="size-4 opacity-50" />}
						onChange={(e) => {
							hqAddr.autocomplete.input.onChange(e.target.value)
						}}
					/>
				</AddressAutocomplete>

				<div className="h-[220px] relative mt-2">
					<OSMapComponent
						view={[hqAddr.view, hqAddr.setView]}
						marker={hqAddr.marker}
						initial={hqAddr.initial}
					/>
				</div>
			</div>
			<Button
				onClick={() => {
					if (!hqAddr.autocomplete.selectedPlace) return

					const { lat, lon } = hqAddr.autocomplete.selectedPlace
					setAddress(defaultAddress)

					props.onSaveAddress({
						address: hqAddr.autocomplete.selectedPlace.displayName,
						latlon: [lat, lon],
					})
				}}
				className="self-end"
				size={"default"}
			>
				Save
			</Button>
		</div>
	)
}
